import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragment;
}

const ActivityLogTaskRequirementApplicationDebriefAdded: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.addedDebriefRequirement"
    />
  );
};

ActivityLogTaskRequirementApplicationDebriefAdded.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementApplicationDebriefAdded_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementApplicationDebriefAdded;
